import { createIsPublicPath } from "@yk/frontend-core";

export const isPublicPath = createIsPublicPath({ paths: ["/login"] });
